<template>
    <div>
        <div class="login-mode" v-if="toggle === 'login'">
            <p>관리자 로그인</p>
            <input type="text" placeholder="id" v-model="id">
            <input type="password" placeholder="password" v-model="password">
            <button class="btn" v-on:click="submit">로그인</button>
        </div>
        <div class="admin" v-if="toggle === 'admin'">
            <div class="cate">
                <p class="cate-t">공지사항</p>
                <div class="write-mode">
                    <input type="text" v-model="title" placeholder="제목">
                    <textarea name="" id="" cols="30" rows="10" v-model="text" placeholder="내용을 입력하세요."></textarea>
                    <button v-on:click="writeNotice" class="btn">작성</button>
                </div>    
                <table class="admin-notice-board">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>제목</th>
                            <th>날짜</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, idx) in notice" :key="idx">
                            <td>{{ idx + 1 }}</td>
                            <td>{{ item.title }}</td>
                            <td>{{ convertDate(item.date) }}</td>
                        </tr>
                    </tbody>
                </table>            
            </div>
            <div class="cate">
                <p class="cate-t">책 쓰기</p>
                <div class="write-mode">
                    <input type="text" placeholder="책 제목" v-model="name">
                    <input type="text" placeholder="저자" v-model="author">
                    <input type="text" placeholder="출판 연도" v-model="date">
                    <textarea cols="30" rows="10" placeholder="책 소개" v-model="introduce"></textarea>
                    <textarea cols="30" rows="10" placeholder="목차" v-model="table"></textarea>
                    <textarea cols="30" rows="10" placeholder="저자 소개" v-model="author_introduce"></textarea>
                    <button class="btn">작성</button>
                </div>
                <ul class="book-list">
                    <li></li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import db from './config';
import dateMix from './mixin/date';

export default {
    name: 'Admin',
    mixins: [ dateMix],
    data: function () {
        return {
            toggle: 'admin',

            title: '',
            text: '',

            id: '',
            password: '',

            name: '',
            author: '',
            date: '',
            introduce: '',
            table: '',
            author_introduce: '',
            
            notice: []
        };
    },
    created() {
		let arr = [];
		window.addEventListener('wheel', this.scrollAuto, { passive: false, capture: 'bubble' });
		db.collection('notice').get().then((querySnapshot) => {
			querySnapshot.forEach((doc) => {
				arr.push(doc.data());
			});
			arr.sort((a, b) => {
				return b.date - a.date;
			})
			this.notice = arr;
		});
    },
    methods: {
        submit() {
            if (this.id === 'ltbooks' && this.password === 'bookslt') {
                this.toggle = 'admin';
                return ;
            }
            alert('아이디 또는 비밀번호가 맞지 않습니다.');
        },
		writeNotice() {
			db.collection('notice').add({ title: this.title, text: this.text, date: new Date().getTime() }).then((docRef) => {
				console.log(docRef.id);
                alert('작성 완료!');
                this.title = '';
                this.text = '';
			}).catch((error) => {
				console.error(error);
			});
		},
        writeBook() {
            db.collection('book').add({ title: this.title, text: this.text, date: new Date().getTime() }).then((docRef) => {
				console.log(docRef.id);
                alert('작성 완료!');
                this.name = '';
                this.text = '';
			}).catch((error) => {
				console.error(error);
			});
        },
        convertDate(date) {
			let ddd = new Date(date);
			return `${ ddd.getFullYear() }-${ (ddd.getMonth() + 1) < 10 ? '0' + (ddd.getMonth() + 1) : ddd.getMonth() }-${ ddd.getDate() < 10 ? '0' + ddd.getDate() : ddd.getDate() }`;
		},
    }
}
</script>
<style>
.admin {
    display: flex;
    width: 100vw;
    height: 100vh;
}
.admin .cate {
    width: 50vw;
}
.admin .cate:nth-child(1) {
    border-right: 1px solid #06623b;
}
.admin .cate .cate-t {
    font-weight: 600;
    font-size: 28px;
    text-align: center;
    margin-top: 50px;
}
.write-mode {
    width: 500px;
    margin: 0 auto;
    padding-top: 65px;
}
.login-mode {
    width: 182px;
    margin: 0 auto;
    padding-top: 100px;
}
.login-mode p, .write-mode p {
    font-size: 25px;
    font-weight: 600;
    margin-bottom: 20px;
}
textarea {
    resize: none;
}
.write-mode textarea, .write-mode input {
    width: inherit;
}
.login-mode input, .write-mode input, .write-mode textarea {
    border: 1px solid #649d66;
    padding: 5px;
    display: block;
    margin-bottom: 20px;
}
.login-mode ::-webkit-input-placeholder, .write-mode ::-webkit-input-placeholder {
    color: #649d66;
}
.btn {
    background-color: #649d66;
    border: none;
    color: white;
    padding: 5px 15px;
    margin-bottom: 100px;
}
.close-btn {
    color: #649d66;
    border: 1px solid #649d66;
    padding: 5px 15px;
    margin-left: 20px;
    background-color: white;
}
.admin-notice-board {
	width: 1000px;
	margin: 0 auto;
	text-align: center;
}
.admin-notice-board thead {
	background-color: #649d66;
}
.admin-notice-board th {
	padding: 5px 0;
	color: white;
	font-weight: 300;
}
.admin-notice-board td {
	padding: 5px 0;
	font-size: 15px;
}
.admin-notice-board tbody tr:hover {
    background-color: rgb(246, 245, 120, 0.5);
    cursor: pointer;
}
</style>